export default "__VITE_ASSET__uyypoh_k__"